import React from 'react';

import { Link } from 'react-router-dom';
import footer from '../images/footslogo.png'


const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section about">
            <h3>About Us</h3>
            <p>
              Hotel Majestic is a luxurious haven of elegance and comfort 🌟🏨, nestled in the heart of the city 🌆. Renowned for its world-class service and opulent ambiance 🛋️✨, this five-star destination offers guests an unforgettable stay. The rooms and suites are exquisitely designed, blending modern sophistication with timeless charm 🛌🖼️. Guests can indulge in culinary delights 🍽️ from around the world at the hotel’s award-winning restaurants, or unwind with a refreshing cocktail at the rooftop bar 🍸🌇, boasting panoramic city views.
            </p>
          </div>

          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul style={{ marginLeft: '60px' }}>
              <li><Link to="/">Home</Link></li><br />
              <li><Link to="/about">About</Link></li><br />
              <li><Link to="/Catogery">Services</Link></li><br />
              <li><Link to="/gallery">Gallery</Link></li><br />
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section services">
            <h3>Services</h3>
            <ul className="interior-services-list">
              <li>Luxury Room </li>
              <li>Delux Room </li>
              <li>Family Room</li>
              <li>Tourist Room</li>
            </ul>  
          </div>

          <div className="footer-section contact">
            <h3>Contact</h3>
            <p>✉️ majestichomes.24@gmail.com</p>
            <p> 📞 Phone: +91 8948104810</p>
            <p>  📞 Phone: +91 9198712300</p>
            <p>📍 Address Majestic Hotel: 46/46A, Doodh Mandi road, near Muslim Musafir Khana, opposite Hotel Kaveri, Cash and Pay Colony, Charbagh, Lucknow, Uttar Pradesh 226004 </p>

            <p>📍 Address Megha Hotel :  R-9, Doodh Mandi Road, near muslim musafir khana, Cash and Pay Colony, Charbagh, Lucknow, Uttar Pradesh 226004</p>


          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Majestic  HOTEL   All Rights Reserved.</p>

          <p>Powered By <img src={footer} />   </p>

        </div>
      </footer>

      {/* Sticky WhatsApp Button */}
      <a
        href="https://wa.me/8948104810"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" />
      </a>
      <a
        href="tel:8948104810"
        className="call-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="https://img.icons8.com/color/48/000000/phone.png" alt="Call" />
      </a>

      <div className="icon-bar">
        <a href="#" class="facebook"><i class="fa fa-facebook"></i></a>
        <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>
        <a href="#" class="google"><i class="fa fa-google"></i></a>
        <a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a>
        <a href="#" class="youtube"><i class="fa fa-youtube-play"></i></a>
      </div>


    </>
  );
};

export default Footer;
